import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PatientReport } from '@/pages/patients/PatientReport';

export default function StandaloneReportPage() {
    const { patientId } = useParams<{ patientId: string }>();
    const navigate = useNavigate();

    if (!patientId) return null;

    return (
        <div className="force-light min-h-screen">
            {/* Back button — always visible so the user can leave the report on any platform */}
            <div
                className="sticky top-0 z-10 flex items-center gap-2 px-4 pb-3 bg-white/90 backdrop-blur border-b border-border/40"
                style={{ paddingTop: 'max(12px, env(safe-area-inset-top))' }}
            >
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => navigate(`/app/family/${patientId}`)}
                    className="gap-2 text-sm font-medium"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Voltar
                </Button>
            </div>
            <div className="p-4 md:p-8">
                <PatientReport patientId={patientId} />
            </div>
        </div>
    );
}
